import { ref, readonly } from "vue";
import { visitLabApi, type VisitLabOrderSummary } from "@/api/visitLab.api";

/**
 * Reactive wrapper for customer visit-lab list.
 * Cursor-based pagination — newest first.
 * แยกออกจาก useHealthReport อย่างสมบูรณ์
 */
export function useVisitLabs() {
  const items = ref<VisitLabOrderSummary[]>([]);
  const hasMore = ref(false);
  const loading = ref(false);
  const error = ref<string | null>(null);

  /** โหลดหน้าแรก (reset list) */
  async function refresh(params?: {
    appointmentId?: string;
    fromDate?: string;
    toDate?: string;
  }): Promise<void> {
    loading.value = true;
    error.value = null;
    try {
      const res = await visitLabApi.list({ limit: 20, ...params });
      items.value = res.items;
      hasMore.value = res.hasMore;
    } catch (e) {
      error.value = (e as Error).message;
    } finally {
      loading.value = false;
    }
  }

  /** โหลดหน้าถัดไป (append) */
  async function loadMore(): Promise<void> {
    if (!hasMore.value || loading.value) return;
    const lastItem = items.value[items.value.length - 1];
    if (!lastItem) return;
    loading.value = true;
    try {
      const res = await visitLabApi.list({
        limit: 20,
        cursor: lastItem.orderId,
      });
      items.value = [...items.value, ...res.items];
      hasMore.value = res.hasMore;
    } catch (e) {
      error.value = (e as Error).message;
    } finally {
      loading.value = false;
    }
  }

  return {
    items: readonly(items),
    hasMore: readonly(hasMore),
    loading: readonly(loading),
    error: readonly(error),
    refresh,
    loadMore,
  };
}

